module.exports = __webpack_public_path__ + "static/media/direction1 icon.891b99fe.svg";